/**
 * @generated SignedSource<<181bd0e8a9cf16549dcddc3d7628288f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AnnouncementLinkInput = {
  attachment?: FileInput | null;
  nodeId?: string | null;
};
export type FileInput = {
  uploadToken: string;
};
export type CreateAnnouncementOverlay_createDraftAnnouncement_Mutation$variables = {
  links: ReadonlyArray<AnnouncementLinkInput>;
  message: string;
  spaceId: string;
};
export type CreateAnnouncementOverlay_createDraftAnnouncement_Mutation$data = {
  readonly createDraftAnnouncement: {
    readonly announcementCreated: {
      readonly id: string;
    };
  } | null;
};
export type CreateAnnouncementOverlay_createDraftAnnouncement_Mutation = {
  response: CreateAnnouncementOverlay_createDraftAnnouncement_Mutation$data;
  variables: CreateAnnouncementOverlay_createDraftAnnouncement_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "links"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "message"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "links",
            "variableName": "links"
          },
          {
            "kind": "Variable",
            "name": "message",
            "variableName": "message"
          },
          {
            "kind": "Variable",
            "name": "spaceId",
            "variableName": "spaceId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "AnnouncementsCreateDraftMutationPayload",
    "kind": "LinkedField",
    "name": "createDraftAnnouncement",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Announcement",
        "kind": "LinkedField",
        "name": "announcementCreated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateAnnouncementOverlay_createDraftAnnouncement_Mutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateAnnouncementOverlay_createDraftAnnouncement_Mutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "eb6f10c3d22c996881daa4e300a44767",
    "id": null,
    "metadata": {},
    "name": "CreateAnnouncementOverlay_createDraftAnnouncement_Mutation",
    "operationKind": "mutation",
    "text": "mutation CreateAnnouncementOverlay_createDraftAnnouncement_Mutation(\n  $message: String!\n  $spaceId: ID!\n  $links: [AnnouncementLinkInput!]!\n) {\n  createDraftAnnouncement(input: {message: $message, spaceId: $spaceId, links: $links}) {\n    announcementCreated {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1798fa957d831cd2a77b5ffaaca17e9";

export default node;
